//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpIcon from '../icon/Icon.vue';

export default {
  name: 'DpWidgetLoader',
  components: { DpIcon },
  props: {
    active: { type: Boolean, default: true },
    topOffset: { type: Number, default: 0 },
    anchorTop: { type: Boolean, default: false },
  },
  computed: {
    offsetStyles() {
      const { topOffset } = this;
      return {
        height: `calc(100% - ${topOffset}px)`,
        top: `${topOffset}px`,
      };
    },
  },
};
